import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/jobUsageReport'
import Component from 'components/Reports/JobUsageReport'

export default createListViewContainer({ actions, selectors: selectors.jobUsageReport })(Component)
